<div class="container config-widget" [ngClass]="{'visible':languageLoaded}">
    <div *ngIf="moduleAvailable('devices')" class="row tab-row">
        <div class="container tab-container underlined">
            <div class="md-12">
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','ThemaFast')" 
                [ngClass]="{'selected':cfg.isVariant('ThemaFast')}"
                (click)="getSimulatorConfig().setVariant('ThemaFast')">
                    <div class="tab-content">ThemaFast</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','ThemaFastCondens')" 
                [ngClass]="{'selected':cfg.isVariant('ThemaFastCondens')}"
                (click)="getSimulatorConfig().setVariant('ThemaFastCondens')">
                    <div class="tab-content">ThemaFast Condens</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','ThemaFastMCondens')" 
                [ngClass]="{'selected':cfg.isVariant('ThemaFastMCondens')}"
                (click)="getSimulatorConfig().setVariant('ThemaFastMCondens')">
                    <div class="tab-content">ThemaFast M-Condens</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','ThemaPlus')"
                [ngClass]="{'selected':cfg.isVariant('ThemaPlus')}"
                (click)="getSimulatorConfig().setVariant('ThemaPlus')">
                    <div class="tab-content">ThemaPlus</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','ThemaCondens')"
                [ngClass]="{'selected':cfg.isVariant('ThemaCondens')}"
                (click)="getSimulatorConfig().setVariant('ThemaCondens')">
                    <div class="tab-content">Thema Condens</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','ThemaMCondens')"
                [ngClass]="{'selected':cfg.isVariant('ThemaMCondens')}"
                (click)="getSimulatorConfig().setVariant('ThemaMCondens')">
                    <div class="tab-content">Thema M-Condens</div>
                </div>

                <div class="tab" 
                *ngIf="subModuleAvailable('devices','ThemaPlusCondens')"
                [ngClass]="{'selected':cfg.isVariant('ThemaPlusCondens')}"
                (click)="getSimulatorConfig().setVariant('ThemaPlusCondens')">
                    <div class="tab-content">ThemaPlus Condens</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','IsoMax')"
                [ngClass]="{'selected':cfg.isVariant('IsoMax')}"
                (click)="getSimulatorConfig().setVariant('IsoMax')">
                    <div class="tab-content">IsoMax</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','IsoMaxCondens')"
                [ngClass]="{'selected':cfg.isVariant('IsoMaxCondens')}"
                (click)="getSimulatorConfig().setVariant('IsoMaxCondens')">
                    <div class="tab-content">IsoMax Condens</div>
                </div>

                <div class="tab" 
                *ngIf="subModuleAvailable('devices','IsoTwin')"
                [ngClass]="{'selected':cfg.isVariant('IsoTwin')}"
                (click)="getSimulatorConfig().setVariant('IsoTwin')">
                    <div class="tab-content">IsoTwin</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','IsoTwinCondens')"
                [ngClass]="{'selected':cfg.isVariant('IsoTwinCondens')}"
                (click)="getSimulatorConfig().setVariant('IsoTwinCondens')">
                    <div class="tab-content">IsoTwin Condens</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','IsoTwinMCondens')"
                [ngClass]="{'selected':cfg.isVariant('IsoTwinMCondens')}"
                (click)="getSimulatorConfig().setVariant('IsoTwinMCondens')">
                    <div class="tab-content">IsoTwin M-Condens</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','IsoFast')" 
                [ngClass]="{'selected':cfg.isVariant('IsoFast')}"
                (click)="getSimulatorConfig().setVariant('IsoFast')">
                    <div class="tab-content">IsoFast</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','IsoFastCondens')" 
                [ngClass]="{'selected':cfg.isVariant('IsoFastCondens')}"
                (click)="getSimulatorConfig().setVariant('IsoFastCondens')">
                    <div class="tab-content">IsoFast Condens</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','MasterCondens')"
                [ngClass]="{'selected':cfg.isVariant('MasterCondens')}"
                (click)="getSimulatorConfig().setVariant('MasterCondens')">
                    <div class="tab-content">Master Condens</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','PantherCondens')"
                [ngClass]="{'selected':cfg.isVariant('PantherCondens')}"
                (click)="getSimulatorConfig().setVariant('PantherCondens')">
                    <div class="tab-content">Panther Condens</div>
                </div>
                <div class="tab" 
                *ngIf="subModuleAvailable('devices','TigerCondens')"
                [ngClass]="{'selected':cfg.isVariant('TigerCondens')}"
                (click)="getSimulatorConfig().setVariant('TigerCondens')">
                    <div class="tab-content">Tiger Condens</div>
                </div>

            </div>
        </div>
    </div>
    <div class="row">

        <div *ngIf="moduleAvailable('regelung')" class="config-section col-xl-6 col-md-12 col-12 regelungsstrategie">
            <div class="container">
                <div class="row">
                    <div class="icon col-2 col-md-3"></div>
                    <div class="caption col-10 col-md-9"><span>{{getTranslator().tr('CONFIG_UI_CAPTION_CONTROLTYPES')}}</span></div>
                    <div class="col-12 p-3"></div>
                    <div class="hidden-xs col-3"></div>
                    <div class="content col-9">
                        <form [formGroup]="regelungsForm">
                            <div class="form-row" *ngIf="subModuleAvailable('regelung','standalone')">
                                <div class="col-1"><input type="radio" value="standalone" formControlName="regelung" [attr.disabled]='isDisabled("regelung","standalone")'></div>
                                <label class="col-4 col-md-9" [ngClass]='{"disabled":isDisabled("regelung","standalone")}'>{{getTranslator().tr('CONFIG_CAPTION_STANDALONE')}}</label>
                            </div>
                            <div class="form-row" *ngIf="subModuleAvailable('regelung','witterungsgefuehrt')">
                                <div class="col-1"><input type="radio" value="witterungsgefuehrt" formControlName="regelung" [attr.disabled]='isDisabled("regelung","witterungsgefuehrt")'></div>
                                <label class="col-4 col-md-9" [ngClass]='{"disabled":isDisabled("regelung","witterungsgefuehrt")}'>{{getTranslator().tr('CONFIG_UI_WEATHER_COMPENSATED')}}</label>
                            </div>
                            <div class="form-row" *ngIf="subModuleAvailable('regelung','sensoDIRECT')">
                                <div class="col-1"><input type="radio" value="sensoDIRECT" formControlName="regelung" [attr.disabled]='isDisabled("regelung","sensoDIRECT")'></div>
                                <label class="col-4 col-md-9" [ngClass]='{"disabled":isDisabled("regelung","sensoDIRECT")}'>{{getTranslator().tr('CONFIG_CAPTION_SENSODIRECT')}}</label>
                            </div>
                            <div class="form-row" *ngIf="subModuleAvailable('regelung','regler')">
                                <div class="col-1"><input type="radio" value="regler" formControlName="regelung" [attr.disabled]='isDisabled("regelung","regler")'></div>
                                <label class="col-4 col-md-9" [ngClass]='{"disabled":isDisabled("regelung","regler")}'>{{getTranslator().tr('CONFIG_CAPTION_CONTROL')}}</label>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <hr/>
        </div>

        <div class="container-fluid">
            <div class="row config-footer p-3">
                <div class="col-12">

                    <form [formGroup]="languageForm">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-9">
                                </div>
                                <div class="col-3 p-1">
                                    
                                </div>
                                <div class="col-12 col-md-4">
                                    
                                    <select class="float-left btn m-1" formControlName="language">
                                        <option *ngFor='let lang of availableLanguages' [value]="lang.getCountryCode()">{{lang.getLanguageNameNative()}}</option>
                                    </select>
                                         
                                </div>
                                
                                    
                                <div class="col-12 col-md-8 p-1">
                                    <button (click)="startSimulation($event)"  class="m-1 float-right btn btn-small btn-info bg-sdbg-red" [attr.disabled]='isDisabled("startButton","simulation")'>{{getTranslator().tr('BUTTON_START_SIMULATION_CAPTION')}}</button>
                                    <button (click)="startInstallation($event)" class="m-1 float-right btn btn-small btn-info bg-sdbg-red" [attr.disabled]='isDisabled("startButton","installation")'>{{getTranslator().tr('BUTTON_START_INSTALLATION_CAPTION')}}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>


            </div>
        </div>
    </div>
</div>